import {CSSProperties, ReactElement} from 'react';
import {twMerge} from 'tailwind-merge';

import BeatLoader from './beatLoader';

type TProps = {
  extraStyle?: CSSProperties;
  extraClassname?: string;
};

const Spinner = ({extraStyle, extraClassname}: TProps): ReactElement => (
  <div
    className={twMerge('min-w-[150px] text-center', extraClassname)}
    style={extraStyle}
  >
    <BeatLoader />
  </div>
);

export default Spinner;
